// extracted by mini-css-extract-plugin
module.exports = {"pages":"StoryPreview_pages__2Toim"};